// resolveNotificationLink mapea una notificación de la bandeja a una ruta
// del frontend, o null si el ítem no debe navegar a ningún lado. Despacha
// por event_type, no por resource_type: "submitted" y "closed" comparten
// resource_type "campaign" (services/notify/notify.go, comentario de
// Event) pero navegan a pantallas distintas.
//
// Cada entrada además declara qué capacidad Terreno exige la pantalla
// destino (router.js no tiene guardas a nivel de ruta para /terreno/*, el
// chequeo vive en cada vista — TerrainCampaignEdit.vue/TerrainReviewQueue.vue
// lo revisan igual en su propio created()). Si al usuario ya no le queda esa
// capacidad para cuando abre la notificación (se la quitaron después del
// evento), el ítem se trata como sin enlace en vez de mandarlo a una
// pantalla de error.
const ROUTE_BUILDERS = {
  // Ruta pública del respondente (router.js, allowAnonymous:true) — sin
  // capacidad Terreno requerida, cualquier destinatario autenticado entra.
  published: { build: (id) => `/terreno/campanas/${id}`, permission: null },
  new_member: { build: (id) => `/terreno/campanas/${id}`, permission: null },
  approved: { build: (id) => `/terreno/campanas/${id}`, permission: null },
  // Cola de revisión de la campaña.
  submitted: { build: (id) => `/terreno/campanas/${id}/respuestas`, permission: (t) => !!(t && (t.review || t.manage)) },
  // Edición de campaña (vista de manager).
  closed: { build: (id) => `/terreno/campanas/${id}/editar`, permission: (t) => !!(t && t.manage) },
};

export function resolveNotificationLink(notification, terrainPermissions) {
  if (!notification || !notification.resource_id || !notification.event_type) return null;
  const entry = ROUTE_BUILDERS[notification.event_type];
  if (!entry) return null;
  if (entry.permission && !entry.permission(terrainPermissions)) return null;
  return entry.build(notification.resource_id);
}
